var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9974 17.3337C4.3949 17.3337 0.664062 13.6028 0.664062 9.00033C0.664062 4.39783 4.3949 0.666992 8.9974 0.666992C13.5999 0.666992 17.3307 4.39783 17.3307 9.00033C17.3307 13.6028 13.5999 17.3337 8.9974 17.3337ZM8.9974 15.667C10.7655 15.667 12.4612 14.9646 13.7114 13.7144C14.9617 12.4641 15.6641 10.7684 15.6641 9.00033C15.6641 7.23222 14.9617 5.53652 13.7114 4.28628C12.4612 3.03604 10.7655 2.33366 8.9974 2.33366C7.22929 2.33366 5.53359 3.03604 4.28335 4.28628C3.03311 5.53652 2.33073 7.23222 2.33073 9.00033C2.33073 10.7684 3.03311 12.4641 4.28335 13.7144C5.53359 14.9646 7.22929 15.667 8.9974 15.667ZM13.0732 6.10283L6.0999 13.0762C5.64438 12.7516 5.24614 12.3533 4.92156 11.8978L11.8949 4.92449C12.3504 5.24907 12.7487 5.64731 13.0732 6.10283Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAction);
export default __webpack_public_path__ + "static/media/noAction.61d1afd8eb20a7c62fb22dc8d74630c7.svg";
export { ForwardRef as ReactComponent };